import { Box, Heading } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { useAppContext } from 'hooks/useAppContext'
import { ROLES } from 'lib'
import React from 'react'
import { BonusTiles } from './BonusTiles'
import { SalesTiles } from './SalesTiles'
import { SalesUsersRevenueTable } from './SalesUsersRevenueTable'
import { CommissionProjects } from 'components/sales/commission/CommissionProjects'
import { PreviousRevenueTable } from './PreviousRevenueTable'

const BreadcrumbNav = [
  {
    label: 'Dashboard',
    path: '/dashboard',
    isCurrentPage: true
  }
]

export const Dashboard = () => {
  const { currentUser } = useAppContext()

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Heading size="lg" my={8}>Dashboard</Heading>
        {(currentUser?.role === ROLES.DirectorOfProjectManagement ||
          currentUser?.role === ROLES.ProjectManager ||
          currentUser?.role === ROLES.DesignEngineer ||
          currentUser?.role === ROLES.PermitExpeditor ||
          currentUser?.role === ROLES.InstallationManager
        ) && (
            <BonusTiles my={8} />
        )}
        {currentUser?.role === ROLES.Admin && (
          <>
            <SalesTiles userId="All" my={8} />
            <SalesUsersRevenueTable my={8} />
            <PreviousRevenueTable my={8} />
          </>
        )}
        {currentUser?.role === ROLES.SuperUser && (
          <CommissionProjects isForDashboard={true} />
        )}
        {currentUser?.role === ROLES.SalesUser && (
          <>
            <SalesTiles userId={currentUser?.id} my={8} />
            <CommissionProjects isForDashboard={true} salespersonId={currentUser?.id} />
            <PreviousRevenueTable my={8} />
          </>
        )}
      </Box>
    </>
  )
}
